// canvas-hero.js — Elaramo homepage hero
// Rendert elk product als een statische 3D canvas afbeelding
// via één gedeelde Three.js renderer — exacte visualiser kwaliteit

(function () {

  // ── Weave textuur — identiek aan canvas-visualiser.js
  function makeWeave(rU, rV) {
    const sz = 512;
    const c = document.createElement('canvas');
    c.width = c.height = sz;
    const x = c.getContext('2d');
    x.fillStyle = '#ece8e2';
    x.fillRect(0, 0, sz, sz);
    const pitch = 2;
    for (let row = 0; row < sz; row += pitch) {
      for (let col = 0; col < sz; col += pitch) {
        const ox = (Math.random() - 0.5) * 0.5;
        const oy = (Math.random() - 0.5) * 0.5;
        const cx = col + pitch / 2 + ox;
        const cy = row + pitch / 2 + oy;
        const r = 0.28 + Math.random() * 0.18;
        const alpha = 0.14 + Math.random() * 0.10;
        x.beginPath();
        x.arc(cx, cy, r, 0, Math.PI * 2);
        x.fillStyle = `rgba(80,68,52,${alpha})`;
        x.fill();
        if (Math.random() > 0.5) {
          x.beginPath();
          x.arc(cx + 0.3, cy - 0.3, r * 0.4, 0, Math.PI * 2);
          x.fillStyle = `rgba(255,250,242,${alpha * 0.35})`;
          x.fill();
        }
      }
    }
    for (let i = 0; i < 25000; i++) {
      const a = Math.random() * 0.018;
      x.fillStyle = Math.random() > 0.5 ? `rgba(50,40,28,${a})` : `rgba(240,232,220,${a * 0.7})`;
      x.fillRect(Math.random() * sz, Math.random() * sz, 1, 1);
    }
    const t = new THREE.CanvasTexture(c);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(rU || 3, rV || 2);
    t.encoding = THREE.sRGBEncoding;
    t._sourceCanvas = c;
    return t;
  }

  // ── Bump map — identiek aan canvas-visualiser.js
  function makeBumpCanvas(sz) {
    const c = document.createElement('canvas');
    c.width = c.height = sz;
    const x = c.getContext('2d');
    x.fillStyle = '#909090';
    x.fillRect(0, 0, sz, sz);
    const pitch = 2;
    for (let row = 0; row < sz; row += pitch) {
      for (let col = 0; col < sz; col += pitch) {
        const cx = col + pitch / 2 + (Math.random() - 0.5) * 0.4;
        const cy = row + pitch / 2 + (Math.random() - 0.5) * 0.4;
        x.beginPath();
        x.arc(cx, cy, 0.45, 0, Math.PI * 2);
        x.fillStyle = 'rgba(0,0,0,0.50)';
        x.fill();
      }
    }
    return c;
  }

  // ── Canvas mesh builder — identiek aan canvas-visualiser.js
  function buildCanvasMesh(W, H, D, photoTex, weaveTexture) {
    const group = new THREE.Group();
    const PX = 512;
    const fW = Math.max(1, Math.round(W * PX));
    const fH = Math.max(1, Math.round(H * PX));
    const fD = Math.max(8, Math.round(D * PX));
    const AW = fW * 3 + fD * 2;
    const AH = fH;

    const atlas = document.createElement('canvas');
    atlas.width = AW; atlas.height = AH;
    const ac = atlas.getContext('2d');

    const C = {
      front:  { x: 0,                    y: 0, w: fW, h: fH },
      left:   { x: fW,                   y: 0, w: fD, h: fH },
      right:  { x: fW + fD,              y: 0, w: fD, h: fH },
      top:    { x: fW + fD * 2,          y: 0, w: fW, h: fD },
      bottom: { x: fW + fD * 2 + fW,     y: 0, w: fW, h: fD },
      back:   { x: fW + fD * 2 + fW * 2, y: 0, w: fW, h: fH },
    };

    const TW = W + 2 * D, TH = H + 2 * D;
    const u0 = D / TW, u1 = (D + W) / TW;
    const v0 = D / TH, v1 = (D + H) / TH;

    const img = photoTex && photoTex.image;
    const iw = img ? (img.naturalWidth  || img.width  || 1) : 1;
    const ih = img ? (img.naturalHeight || img.height || 1) : 1;

    function drawPhoto(cell, sx, sy, sw, sh) {
      ac.save();
      ac.translate(cell.x, cell.y + cell.h);
      ac.scale(1, -1);
      if (img) {
        ac.drawImage(img, sx * iw, sy * ih, sw * iw, sh * ih, 0, 0, cell.w, cell.h);
      } else {
        ac.fillStyle = '#d8d3cb';
        ac.fillRect(0, 0, cell.w, cell.h);
      }
      ac.restore();
    }

    function overlayWeave(cell, alpha) {
      const wc = weaveTexture && weaveTexture._sourceCanvas;
      if (!wc) return;
      const tmp = document.createElement('canvas');
      tmp.width = cell.w; tmp.height = cell.h;
      const tc = tmp.getContext('2d');
      const pattern = tc.createPattern(wc, 'repeat');
      tc.fillStyle = pattern;
      tc.scale(cell.w / 256, cell.h / 256);
      tc.fillRect(0, 0, 256, 256);
      ac.save();
      ac.translate(cell.x, cell.y + cell.h);
      ac.scale(1, -1);
      ac.globalCompositeOperation = 'multiply';
      ac.globalAlpha = alpha;
      ac.drawImage(tmp, 0, 0);
      ac.restore();
      ac.globalCompositeOperation = 'source-over';
      ac.globalAlpha = 1;
    }

    function darkenEdges(cell, strength, sides) {
      ac.save();
      const spread = Math.min(cell.w, cell.h) * 0.45;
      sides.forEach(side => {
        let grad;
        if (side === 'top') {
          grad = ac.createLinearGradient(cell.x, cell.y, cell.x, cell.y + spread);
          grad.addColorStop(0, `rgba(0,0,0,${strength})`); grad.addColorStop(1, 'rgba(0,0,0,0)');
          ac.fillStyle = grad; ac.fillRect(cell.x, cell.y, cell.w, spread);
        } else if (side === 'bottom') {
          grad = ac.createLinearGradient(cell.x, cell.y + cell.h, cell.x, cell.y + cell.h - spread);
          grad.addColorStop(0, `rgba(0,0,0,${strength})`); grad.addColorStop(1, 'rgba(0,0,0,0)');
          ac.fillStyle = grad; ac.fillRect(cell.x, cell.y + cell.h - spread, cell.w, spread);
        } else if (side === 'left') {
          grad = ac.createLinearGradient(cell.x, cell.y, cell.x + spread, cell.y);
          grad.addColorStop(0, `rgba(0,0,0,${strength})`); grad.addColorStop(1, 'rgba(0,0,0,0)');
          ac.fillStyle = grad; ac.fillRect(cell.x, cell.y, spread, cell.h);
        } else if (side === 'right') {
          grad = ac.createLinearGradient(cell.x + cell.w, cell.y, cell.x + cell.w - spread, cell.y);
          grad.addColorStop(0, `rgba(0,0,0,${strength})`); grad.addColorStop(1, 'rgba(0,0,0,0)');
          ac.fillStyle = grad; ac.fillRect(cell.x + cell.w - spread, cell.y, spread, cell.h);
        }
      });
      ac.restore();
    }

    // Back face met stretcher bars
    {
      const cell = C.back;
      ac.save();
      ac.translate(cell.x, cell.y + cell.h);
      ac.scale(1, -1);
      const wc = weaveTexture && weaveTexture._sourceCanvas;
      if (wc) {
        const pat = ac.createPattern(wc, 'repeat');
        ac.fillStyle = pat;
        ac.fillRect(0, 0, cell.w, cell.h);
      } else {
        ac.fillStyle = '#e0d9ce';
        ac.fillRect(0, 0, cell.w, cell.h);
      }
      const bw = cell.w, bh = cell.h;
      const bt = Math.max(5, Math.round(bh * 0.045));
      ac.fillStyle = 'rgba(175,162,145,0.92)';
      ac.fillRect(0, 0, bw, bt);
      ac.fillRect(0, bh - bt, bw, bt);
      ac.fillRect(0, 0, bt, bh);
      ac.fillRect(bw - bt, 0, bt, bh);
      ac.fillRect(bw / 2 - bt / 2, 0, bt, bh);
      ac.fillRect(0, bh / 2 - bt / 2, bw, bt);
      ac.restore();
    }

    // Voorkant
    drawPhoto(C.front, u0, v0, u1 - u0, v1 - v0);
    overlayWeave(C.front, 0.07);
    darkenEdges(C.front, 0.07, ['top', 'bottom', 'left', 'right']);

    // Zijkanten (gallery-wrap)
    drawPhoto(C.left,   0,  v0, u0,       v1 - v0); overlayWeave(C.left,   0.18); darkenEdges(C.left,   0.12, ['top','bottom']); darkenEdges(C.left,   0.06, ['right']);
    drawPhoto(C.right,  u1, v0, 1 - u1,   v1 - v0); overlayWeave(C.right,  0.18); darkenEdges(C.right,  0.12, ['top','bottom']); darkenEdges(C.right,  0.06, ['left']);
    drawPhoto(C.top,    u0, 0,  u1 - u0,  v0);       overlayWeave(C.top,    0.18); darkenEdges(C.top,    0.12, ['left','right']); darkenEdges(C.top,    0.06, ['bottom']);
    drawPhoto(C.bottom, u0, v1, u1 - u0,  1 - v1);   overlayWeave(C.bottom, 0.18); darkenEdges(C.bottom, 0.12, ['left','right']); darkenEdges(C.bottom, 0.06, ['top']);

    const tex = new THREE.CanvasTexture(atlas);
    tex.encoding = THREE.sRGBEncoding;
    tex.minFilter = THREE.LinearFilter;
    tex.magFilter = THREE.LinearFilter;
    tex.generateMipmaps = false;
    tex.needsUpdate = true;

    const bumpTex = new THREE.CanvasTexture(makeBumpCanvas(512));
    bumpTex.wrapS = bumpTex.wrapT = THREE.RepeatWrapping;
    bumpTex.repeat.set(W * 12, H * 12);
    bumpTex.needsUpdate = true;

    function UV(cell, targetH) {
      const h = targetH !== undefined ? targetH : cell.h;
      return { u0: cell.x / AW, u1: (cell.x + cell.w) / AW, v0: 1 - (cell.y + h) / AH, v1: 1 - cell.y / AH };
    }
    const geo = new THREE.BoxGeometry(W, H, D, 1, 1, 1);
    const ua = Float32Array.from(geo.attributes.uv.array);
    function setFace(i, u0, v0, u1, v1) {
      const b = i * 8;
      ua[b]=u0; ua[b+1]=v0; ua[b+2]=u1; ua[b+3]=v0;
      ua[b+4]=u0; ua[b+5]=v1; ua[b+6]=u1; ua[b+7]=v1;
    }
    const Ff=UV(C.front), Fl=UV(C.left), Fr=UV(C.right);
    const Ft=UV(C.top,C.top.h), Fb=UV(C.bottom,C.bottom.h), Fk=UV(C.back);
    setFace(0,Fr.u0,Fr.v0,Fr.u1,Fr.v1); setFace(1,Fl.u0,Fl.v0,Fl.u1,Fl.v1);
    setFace(2,Ft.u0,Ft.v0,Ft.u1,Ft.v1); setFace(3,Fb.u0,Fb.v0,Fb.u1,Fb.v1);
    setFace(4,Ff.u0,Ff.v0,Ff.u1,Ff.v1); setFace(5,Fk.u0,Fk.v0,Fk.u1,Fk.v1);
    geo.setAttribute('uv', new THREE.BufferAttribute(ua, 2));

    const mat = new THREE.MeshStandardMaterial({
      map: tex, bumpMap: bumpTex, bumpScale: 0.008,
      roughness: 0.88, metalness: 0,
    });

    group.add(new THREE.Mesh(geo, mat));
    return group;
  }


  // ── Sample 2 dominante kleuren uit een afbeelding
  function getDominantColors(img) {
    const sz = 40;
    const c = document.createElement('canvas');
    c.width = c.height = sz;
    const x = c.getContext('2d');
    x.drawImage(img, 0, 0, sz, sz);

    const pixels = x.getImageData(0, 0, sz, sz).data;
    let colors = [];
    for (let i = 0; i < pixels.length; i += 16) {
      const r = pixels[i], g = pixels[i+1], b = pixels[i+2];
      colors.push([r, g, b]);
    }

    // Sorteer op helderheid
    colors.sort((a, b) => (a[0]+a[1]+a[2]) - (b[0]+b[1]+b[2]));

    // Pak één donkere en één lichte kleur uit de uitersten
    function avg(arr) {
      const n = arr.length;
      const r = Math.round(arr.reduce((s,c)=>s+c[0],0)/n);
      const g = Math.round(arr.reduce((s,c)=>s+c[1],0)/n);
      const b = Math.round(arr.reduce((s,c)=>s+c[2],0)/n);
      return `rgb(${r},${g},${b})`;
    }

    const dark  = avg(colors.slice(0,  Math.floor(colors.length * 0.25)));
    const light = avg(colors.slice(Math.floor(colors.length * 0.75)));
    return [dark, light];
  }

  // ── Bouw een gedeelde Three.js renderer (offscreen)
  function buildRenderer(wallColor) {
    const offscreen = document.createElement('canvas');
    const renderer = new THREE.WebGLRenderer({ canvas: offscreen, antialias: true, alpha: true });
    renderer.setPixelRatio(1);
    renderer.outputEncoding          = THREE.sRGBEncoding;
    renderer.toneMapping             = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure     = 1.38;
    renderer.physicallyCorrectLights = true;

    function buildScene(bgColor) {
      const scene = new THREE.Scene();
      // Geen achtergrond — transparante PNG
      scene.add(new THREE.HemisphereLight(0xfff8f0, 0xe0d8d0, 1.6));
      const key = new THREE.DirectionalLight(0xfff5e8, 2.8);
      key.position.set(3.5, 6, 5); scene.add(key);
      const fill = new THREE.DirectionalLight(0xe8f0ff, 0.75);
      fill.position.set(-5, 1.5, 3); scene.add(fill);
      const rim = new THREE.DirectionalLight(0xffffff, 0.35);
      rim.position.set(0, -4, 2); scene.add(rim);
      return scene;
    }

    return { renderer, offscreen, buildScene };
  }

  // ── Render één product → dataURL
  function renderProduct(shared, product, weaveTexture, wallColor) {
    return new Promise(function(resolve) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        const cw = product.width  || 60;
        const ch = product.height || 40;
        const depth = 2;
        // Zelfde schaal als visualiser: 1.6 / max zodat canvas altijd in beeld past
        const s = 1.6 / Math.max(cw, ch);
        const W = cw * s, H = ch * s, D = depth * s;

        const ratio = cw / ch;
        // Render canvas: landscape altijd, minimaal 4:3 zodat vierkant/portret ruimte heeft
        const RENDER_H = 600;
        const RENDER_W = Math.round(RENDER_H * Math.max(ratio, 1.0));
        shared.offscreen.width  = RENDER_W;
        shared.offscreen.height = RENDER_H;
        shared.renderer.setSize(RENDER_W, RENDER_H, false);

        const scene = shared.buildScene(wallColor);
        // Vaste camera op z:3.2 — zelfde als visualiser
        const camera = new THREE.PerspectiveCamera(34, RENDER_W / RENDER_H, 0.01, 50);
        camera.position.set(0, 0.0, 3.2);
        camera.lookAt(0, 0, 0);

        const photoTex = new THREE.Texture(img);
        photoTex.encoding = THREE.sRGBEncoding;
        photoTex.wrapS = photoTex.wrapT = THREE.ClampToEdgeWrapping;
        photoTex.generateMipmaps = true;
        photoTex.minFilter = THREE.LinearMipmapLinearFilter;
        photoTex.magFilter = THREE.LinearFilter;
        photoTex.needsUpdate = true;

        const group = buildCanvasMesh(W, H, D, photoTex, weaveTexture);
        group.rotation.y = 0;
        group.rotation.x = 0;
        scene.add(group);

        shared.renderer.render(scene, camera);
        const dataUrl = shared.offscreen.toDataURL('image/png');

        // Opruimen
        group.traverse(o => {
          if (o.geometry) o.geometry.dispose();
          if (o.material) [].concat(o.material).forEach(m => {
            if (m.map)     m.map.dispose();
            if (m.bumpMap) m.bumpMap.dispose();
            m.dispose();
          });
        });
        photoTex.dispose();

        // Sample kleuren en geef mee terug
        const [c1, c2] = getDominantColors(img);
        resolve({ dataUrl, c1, c2 });
      };
      img.onerror = function() { resolve({ dataUrl: null, c1: null, c2: null }); };
      img.src = product.image;
    });
  }

  // ── Verwerk producten één voor één (sequentieel om renderer te delen)
  async function renderAll(products, wallColor, indexOffset) {
    indexOffset = indexOffset || 0;
    if (typeof THREE === 'undefined') {
      setTimeout(() => renderAll(products, wallColor), 100);
      return;
    }
    const shared      = buildRenderer(wallColor);
    const weaveTexture = makeWeave(4, 3);

    const allColors = [];

    for (let i = 0; i < products.length; i++) {
      const result = await renderProduct(shared, products[i], weaveTexture, wallColor);
      const el = document.getElementById('ch-img-' + (i + indexOffset));
      if (el && result.dataUrl) {
        el.src = result.dataUrl;
        el.style.transition = 'opacity 1.2s ease';
        el.style.opacity = '1';
        // Gradient achtergrond op de kaart
        if (result.c1 && result.c2) {
          const bg = document.getElementById('ch-imgbg-' + (i + indexOffset));
          if (bg) {
            bg.style.background = 'linear-gradient(135deg, ' + result.c1 + ' 0%, ' + result.c2 + ' 100%)';
            bg.dataset.dotColor = result.c1;
          }
          allColors.push(result.c1, result.c2);
          // Update dot kleur direct
          // Sla kleur op voor later
          const dot = document.querySelector('.ch-dot[data-index="' + (i + indexOffset) + '"]');
          if (dot) {
            dot.dataset.color = result.c1;
            dot.style.background = result.c1;
          }
        }
        // Verberg shimmer
        const shimmer = document.getElementById('ch-shimmer-' + (i + indexOffset));
        if (shimmer) {
          shimmer.style.opacity = '0';
          setTimeout(() => { shimmer.style.display = 'none'; }, 500);
        }
      }
    }

    // Fade in dots na laden — één voor één
    const allDotEls = document.querySelectorAll('.ch-dot');
    allDotEls.forEach(function(d, i) {
      setTimeout(function() {
        requestAnimationFrame(function() { d.style.opacity = '0.4'; });
      }, 300 + i * 160);
    });

    // Update slider teller
    if (window._chUpdateSlider) window._chUpdateSlider(products.length);

    shared.renderer.dispose();
  }

  // ── Public init
  window.initCanvasHero = function(opts) {
    const products = (opts && opts.products) || [];
    const wallColor = (opts && opts.wallColor) || '#F2EFE9';

    // Bouw dots
    const dotsEl = document.getElementById('ch-dots');
    if (dotsEl) {
      dotsEl.innerHTML = '';
      for (let i = 0; i < products.length; i++) {
        const dot = document.createElement('div');
        dot.className = 'ch-dot';
        dot.dataset.index = String(i);
        dot.dataset.color = '#cccccc';
        dot.style.cssText = 'width:9px;height:9px;border-radius:50%;background:#cccccc;cursor:default;opacity:0;flex-shrink:0;transition:transform 0.3s,opacity 1.2s,box-shadow 0.3s,background 0.8s;display:inline-block;';
        dotsEl.appendChild(dot);
      }
    }

    // Op mobiel: render huidige kaart eerst, dan rest met vertraging
    const isMobileInit = window.innerWidth < 768;
    if (isMobileInit) {
      // Render eerste kaart direct
      renderAll(products.slice(0, 1), wallColor).then(function() {
        // Daarna rest met kleine vertraging
        setTimeout(function() {
          renderAll(products.slice(1), wallColor, 1);
        }, 800);
      });
    } else {
      renderAll(products, wallColor);
    }
  };


})();
